const getBaseUrl = () => '/request';
export const getRootUrl = () => getBaseUrl();

/*
 * Keep imports here to minimal as this is used in the early request
 * e.g. don't use enviro
 */
const rootApiUrl = 'privacy-center-public/v1/data-privacy-request';
export const getApiUrl = () => {
  const {
    origin
  } = window.location;
  if (origin.includes('local.hs-data-privacyqa.com')) {
    // Can only run NA1 QA locally
    return `https://na1.hs-data-privacyqa.com/${rootApiUrl}`;
  }
  return `${origin}/${rootApiUrl}`;
};